<div class="header2 hoverarea">

    <span class="cbContainer">
        <input type="checkbox" (click)="addRemoveAll()">
    </span>

    <ng-content select=".list-header"></ng-content>
        <!--<ng-content select=".list-header-content"></ng-content>-->

    <btn
      label="détails"
      type="actionMore"
      (click)="m_viewDetailsFlag = !m_viewDetailsFlag"
      click-stop>
        <span class="icon">
            <fa-icon [icon]="m_viewDetailsFlag ? iconEyeSlash : iconEye"></fa-icon>
        </span>
    </btn>

    <!--
        <ng-content select=".list-header-action"></ng-content>
    -->

</div>

<div
  *ngFor="let item of (list | values); let i = index" class="style-2 list-row"
  [class.disabled]="isDisabled( item.id )">

    <span *ngIf="type === 'string'">
      <span class="checkboxContainer">
          <input
            class="checkbox"
            type="checkbox"
            [checked]="isChecked(item)"
            [disabled]="isDisabled( item.id )">
      </span> {{item }}
    </span>

    <div *ngIf="type === 'traveller'" (click)="addRemoveItem(item.id)" class="list-item">
        <span class="checkboxContainer">
          <input
            type="checkbox"
            [checked]="isChecked(item.id)"
            [disabled]="isDisabled( item.id )">
      </span>
        <traveller [travellerItem]="item" [travellerKey]="item.xID" [showDetails]="m_viewDetailsFlag"></traveller>
    </div>

    <div *ngIf="type === 'travellersynchronyme'" (click)="addRemoveItem(item.id)" class="list-item">
        <span class="checkboxContainer">
        <input
          type="checkbox"
          [checked]="isChecked(item.id)"
          [disabled]="isDisabled( item.id )">
    </span>
        <traveller-synchronyme
          [travellerItem]="item"
          [travellerKey]="item.xID"
          [showDetails]="m_viewDetailsFlag"
          (showTnrEvent)="showTnr($event)"
          (showPnrEvent)="showPnr($event)"></traveller-synchronyme>
    </div>


</div>
